/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The screen a playslip message appears on, so the back office can list them together.
 * @export
 */
export const PlayslipMessageGroup = {
    _11184809: '11184809',
    actions: 'actions',
    headings: 'headings',
    order: 'order',
    savedOrders: 'savedOrders',
    barcodes: 'barcodes',
    prizes: 'prizes',
    games: 'games',
    prompts: 'prompts',
    optionRows: 'optionRows',
    banner: 'banner',
    confirmations: 'confirmations',
    errors: 'errors',
    unknown_default_open_api: '11184809'
} as const;
export type PlayslipMessageGroup = typeof PlayslipMessageGroup[keyof typeof PlayslipMessageGroup];


export function instanceOfPlayslipMessageGroup(value: any): boolean {
    for (const key in PlayslipMessageGroup) {
        if (Object.prototype.hasOwnProperty.call(PlayslipMessageGroup, key)) {
            if (PlayslipMessageGroup[key as keyof typeof PlayslipMessageGroup] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PlayslipMessageGroupFromJSON(json: any): PlayslipMessageGroup {
    return PlayslipMessageGroupFromJSONTyped(json, false);
}

export function PlayslipMessageGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayslipMessageGroup {
    return json as PlayslipMessageGroup;
}

export function PlayslipMessageGroupToJSON(value?: PlayslipMessageGroup | null): any {
    return value as any;
}

